// **************** react import *******************
import React, { useState, useEffect, useCallback } from "react";

// ******************** Components  *******************

import CommonHeader from "../../../components/common-header";
import Table from "../../../components/table/table";
import { ConfirmPopup } from "../../../components/model-popup/confirmation-popup";
import { CustomButton } from "../../../components/buttons/button";

// ********************* utils function ***************
import { ChildProps } from "../../../utils/types/interFace";
import { debounce } from "../../../utils/redirections";

// ********************************* interface  ********************************
import { sortInterFace } from "../../../utils/types/interFace";

// ******************************** API & REDUX ***************
import { useDispatch, useSelector } from "react-redux";
import { getPCCLocation } from "../../../api/list";


// ********************* icons ***************
import EditIcon from "../../../assets/icons/edit.png";
import DeleteIcon from "../../../assets/icons/trash.png";


// ********************* edit popup ***************
import { LocationPopup } from "./location-popup";

// ********************* toast ***************
import { toast} from "react-toastify";
import { DeleteMappedLocation, FetchMappedLocationList } from "../../../redux/slices/mapping.slice";




const LocationMapping = ({filteredAccess}:ChildProps) => {
  const dispatch: any = useDispatch();
  const [loader, setLoader] = useState<boolean>(true);
  const userAccess = filteredAccess.length !== 0 ? filteredAccess[0] : {}
  const NotesErrorData = useSelector(
    (state: any) => state?.MappedDataList?.MappedLocationList || {}
  );


  const [facList,setFacList] = useState([])

  // ********************for table
  //
  const [filterStatus, ] = useState("");

  // search
  const [showSearch, setShowSearch] = useState("");
  const [search, setSearch] = useState<string>("");
  // const handleSearch = useCallback(debounce(setSearch, 500), []);
  const handleSearch = useCallback(
    debounce((val: string) => {
      setSearch((prev) => (prev !== val ? val : prev));
    }, 500),
    []
  );

  // sort
  const [sort, setSort] = useState<sortInterFace>({ created_at: "asc" });

  const [limit, ] = useState<number>(15);
  const [page, setPage] = useState<number>(1);
  const [totalPage, setTotalPage] = useState<number>(1);
  const [totalRecord, setTotalRecord] = useState<number>(0);

  // editview
  const [ViewDetails, setViewDetails] = useState<any>({});
  const [modelTitle, setModelTitle] = useState<string>("");
  const [showModal, setShowModal] = useState<boolean>(false);
  const [, setPopupDetails] = useState<any>({});

  // deletes
  const [showDeleteModel, setShowDeleteModel] = useState<boolean>(false);
  const [buttonLoader, setButtonLoader] = useState<boolean>(false);

  // handle the loading the data
  const handleMappedLocationData = (
    load: boolean,
    sorting: any = {},
    pageNumber?: number
  ) => {
    pageNumber && setPage(pageNumber);
    if (pageNumber || page === 1) {
      setLoader(load);
    }
    dispatch(
      FetchMappedLocationList({
        page: pageNumber || page,
        limit,
        status: filterStatus,
        sort_by:
          Object.keys(sorting).length !== 0
            ? Object.keys(sorting)[0]
            : "created_at",
        sort_dir:
          Object.keys(sorting).length !== 0
            ? sorting[Object.keys(sorting)[0]]
            : "asc",
        search_value: search,
      })
    ).then((res: any) => {
      setTotalPage(res?.payload?.result?.total_pages);
      setTotalRecord(res?.payload?.result?.total_count);
      setLoader(false);
    });
  };

  const handleNextPage = () => {
    setPage(page + 1);
  };

  const afterChangeMappingList = () => {
    if (page === 1) {
      handleMappedLocationData(true, sort);
      setViewDetails({});
    } else {
      setPage(1);
    }
  };

  const handleDelete = async () => {
    setButtonLoader(true);
    dispatch(DeleteMappedLocation([ViewDetails?.id]))
    .unwrap()
    .then((res: any) => {
      setShowDeleteModel(false);
      if (res?.result) {
        afterChangeMappingList();
        setViewDetails({});
        toast.success("Location deleted successfully");
      } else {
        toast.error(res?.message || "User delete failed");
      }
      setButtonLoader(false);
    });
  };




  /**
     * @function handleFaclities
     * @returns
     * @description handle faclities
     * */
    const handleFaclities = async () => {
      try {
        const result = await getPCCLocation();
        if (result?.result) {
          setFacList(result?.result?.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };



  useEffect(() => {
    handleFaclities();
  }, []);
  
  // Debounce search input
  useEffect(() => {
    handleSearch(showSearch);
  }, [showSearch]);
  
  // Reset page when filters change
  useEffect(() => {
    setPage(1);
  }, [limit, search, filterStatus]);
  
  // Fetch data on page or sort change
  useEffect(() => {
    handleMappedLocationData(true, sort);
  }, [page, sort,search]);


  return (
    <div className="w-full p-[10px] pl-[2px] pr-[2px]">
      <div className="pt-[16px]  pl-[2px] pr-[2px] bg-white rounded-[12px]">
        <CommonHeader
          addNew={userAccess.write_access}
          heading="Location ID Mapping"
          description="This table maps system-generated location 
          identifiers across platforms to ensure accurate and consistent location recognition."
          onclickAddButton={() => {
            setShowModal(true);
            setPopupDetails({});
            setModelTitle("Add New Location Mapping");
          }}
          totalCount={totalRecord}
          countForText="Results"
          setShowSearch={setShowSearch}
          showSearch={showSearch}
          search
        />
        <Table
          loading={loader}
          data={NotesErrorData}
          tableScroll={"100%"}
          sort={true}
          hasNextPage={page < totalPage}
          NextPageData={handleNextPage}
          columns={[
            "Source Location",
            "Location",
            "Facility ID",
            "Org ID",
            "Updated By",
            ...(userAccess.delete_access || userAccess.update_access ? ["Action"] : [])
          ]}
          sortTitleKeys={{
            "Source Location": "source_location",
            Location: "pcc_location",
            "Facility ID": "facId",
            "Org ID": "orgId",
            "Updated By": "updated_by_name",
          }}
          handleSortfunc={(key: any, value: any) => {
            setSort({ [key]: value });
            page === 1
              ? handleMappedLocationData(false, { [key]: value })
              : handleMappedLocationData(false, { [key]: value }, 1);
          }}
          scopedSlots={{
            "Source Location": ({ row }: any) => (
              <td title={`${row?.source_location || ""}`}>
            
                    <div className="max-w-[200px] truncate">
                      {![null, ""].includes(row.source_location) &&
                        ![null, ""].includes(row.source_location)
                        ? `${row.source_location}`
                        : row.source_location}
                    </div>
              </td>
            ),
            Location: ({ row }: any) => (
              <td title={row?.pcc_location || ""}>
                <div className=" max-w-[150px] truncate ">
                  {row?.pcc_location || ""}
                </div>
              </td>
            ),
            "Facility ID": ({ row }: any) => (
              <td title={row?.facId || ""}>
                <div className=" max-w-[150px] truncate ">
                  {row?.facId || ""}
                </div>
              </td>
            ),
            "Org ID": ({ row }: any) => (
              <td title={row?.orgId || ""}>
                <div className=" max-w-[150px] truncate">
                  {row?.orgId || ""}
                </div>
              </td>
            ),
              'Updated By': ({ row }: any) => (
              <td title={row?.updated_by_name || ""}>
                <div className=" max-w-[150px] truncate ">
                  {/* {row?.updated_by ? WordTitle(row?.updated_by) : ''} */}
                  {row?.updated_by_name ? row?.updated_by_name : ''}
                </div>
              </td>
            ),
            Action: ({ row }: any) => {
              return (
                <td onClick={(e) => e.stopPropagation()}>
                  <div  className="flex gap-[16px] items-center justify-center pr-[4px]">
                    { 
                      userAccess.update_access && 
                      <img
                        src={EditIcon}
                        alt="Edit"
                        className="cursor-pointer w-[18px] h-[18px]"
                        onClick={(e) => {
                          e.stopPropagation(); 
                          setViewDetails(row);
                          setModelTitle("Update location");
                          setShowModal(true);
                        }}
                      />
                    }
                     
                     {
                      userAccess.delete_access && 
                      <img
                        src={DeleteIcon}
                        onClick={(e) => {
                          e.stopPropagation(); 
                          setShowDeleteModel(true);
                          setViewDetails(row);
                        }}
                        alt="Delete"
                        className="cursor-pointer w-[18px] h-[18px]"
                      />
                     }
                    
                  </div>
                </td>
              );
            },
          }}
        />

        {/* *************************** editing modal *******************/}
        {showModal ? (
          <LocationPopup
            showModal={showModal}
            setShowModal={setShowModal}
            afterChangeMappingList={afterChangeMappingList}
            handleClose={() => {
              setViewDetails({});
              setShowModal(false);
            }}
            title={modelTitle}
            setTitle={setModelTitle}
            poupDetails={ViewDetails}
            facList={facList}

          />
        ) : null}

        <ConfirmPopup showModal={showDeleteModel} icon>
          <div className="text-[16px] font-semibold text-center text-[#061018] line-height-[24px]">
            Remove Notes?
          </div>
          <div className="text-[12px] font-normal text-center text-[#061018] mt-[8px] mb-[16px] ">
            You are about to delete{" "}
            <span className="font-semibold">
              {`“${ViewDetails?.source_location}”`}
            </span> {" "}
           
          </div>
          <div className="flex justify-center gap-[16px] items-center w-full">
            <CustomButton
              buttonName="No, Keep it"
              primary={false}
              buttonStyle="w-full text-[#1C252D] text-[14px] p-[12px] text-[14px] font-semibold leading-[17px]   "
              disable={buttonLoader}
              onClick={() => {
                setShowDeleteModel(false);
                setViewDetails({});
              }}
            />
            <CustomButton
              buttonName="Yes, Remove !"
              buttonStyle="w-full text-white bg-[#D41E1E] 
              hover:bg-[#B51C1C] text-[14px] p-[12px] 
              text-[14px] font-semibold leading-[17px]   "
              loader={buttonLoader}
              disable={buttonLoader}
              loaderStyle="w-full bg-[#D41E1E]/80  py-[13px] "
              onClick={() => {
                handleDelete();
              }}
            />
          </div>
        </ConfirmPopup>
      </div>
    </div>
  );
};

export default LocationMapping;
